import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourseService } from 'src/app/services/course.service';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-course-play',
  templateUrl: './course-play.component.html',
  styleUrls: ['./course-play.component.scss']
})
export class CoursePlayComponent implements OnInit {

  constructor(private router: Router, private sanitizer: DomSanitizer, private courseService: CourseService) { }
  modules: any[] = [];
  lessons: any[] = [];
  courseId: any;
  moduleId: any;
  activeModuleIndex: any = 0;
  activeLessonIndex: any = 0;
  selectedLesson: any = {};
  quiz: any;
  isQuiz: boolean = false;
  isLesson: boolean = true;
  isShowingQuiz: boolean = false;
  purchasedCourseId: any = JSON.parse(sessionStorage.getItem("purchasedCourseId"));
  courseDetails: any;
  apiURL: string = environment.apiURL;
  isFeedback: boolean = false;

  ngOnInit(): void {
    let url = this.router.url.split('/');
    this.courseId = url[3];
    this.courseService.getCourse(this.courseId).subscribe(
      (res: any) => {
        this.courseDetails = _.get(res, 'course');
      }
    )
    this.getAllModules();
    this.getLatestPlayedVideo();
  }

  onClickModule(index, clickLesson = false) {
    this.activeModuleIndex = index;
    this.moduleId = this.modules[index]._id;
    this.modules[index].active = !this.modules[index].active;
    for (let i = 0; i < this.modules.length; i++) {
      if (i !== index) {
        this.modules[i]['active'] = false;
      }
    }
    this.getAllLessons(this.modules[index]._id, clickLesson);
    this.courseService.getQuiz(this.courseId, this.moduleId, this.modules[index].quiz).subscribe(
      (res: any) => {
        if (res.questions.length) {
          this.isShowingQuiz = true;
        } else {
          this.isShowingQuiz = false;
        }
      }
    )
  }

  onDownloadMaterial(event, base64String, fileName) {
    event.stopPropagation();
    const source = `data:application/pdf;base64,${base64String}`;
    const link = document.createElement("a");
    link.href = source;
    link.download = `${fileName}`
    link.click();
  }

  onClickLesson(index) {
    this.activeLessonIndex = index;
    this.isQuiz = false;
    this.isFeedback = false;
    this.lessons[index].active = true;
    this.selectedLesson = {};
    this.isLesson = false;
    this.onGetLesson(this.lessons[index]?._id);
    for (let i = 0; i < this.lessons.length; i++) {
      if (i !== index) {
        this.lessons[i]['active'] = false;
      }
    }
  }

  onGetQuiz(quizId) {

  }

  onGetLesson(lessonId) {
    if (lessonId) {
      this.courseService.getLesson(this.courseId, this.moduleId, lessonId).subscribe(
        (res: any) => {
          this.selectedLesson = { ...res };
          this.selectedLesson = { ...this.selectedLesson };
          this.isLesson = true;
          this.courseService.updateLastPlayedCourse(this.purchasedCourseId, lessonId, this.moduleId).subscribe();
        }
      )
    }
  }

  onClickQuiz(index) {
    this.isLesson = false;
    this.isQuiz = true;
    this.isFeedback = false;
    this.courseService.getQuiz(this.courseId, this.moduleId, this.modules[index].quiz).subscribe(
      (res: any) => {
        this.quiz = res;
      }
    )
  }

  getAllModules() {
    this.courseService.getAllModules(this.courseId).subscribe(
      (res: any) => {
        this.modules = _.cloneDeep(res);
        for (let i = 0; i < this.modules.length; i++) {
          if (this.moduleId && this.moduleId === this.modules[i]._id) {
            this.onClickModule(i);
          }
          else {
            this.modules[i]['active'] = false;
          }
        }
      }
    )
  }

  getAllLessons(moduleId, clickLesson = false) {
    this.courseService.getAllLessons(this.courseId, moduleId).subscribe(
      (res: any) => {
        this.lessons = _.cloneDeep(res);
        for (let i = 0; i < this.lessons.length; i++) {
          this.lessons[i]['active'] = false;
        }
        if (clickLesson) {
          this.onClickLesson(this.activeLessonIndex);
        }
      }
    )
  }

  getVideo(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  onCompleteQuiz(event) {
    if (event && this.modules.length - 1 > this.activeModuleIndex) {
      this.activeModuleIndex = this.activeModuleIndex + 1;
      this.activeLessonIndex = 0;
      this.onClickModule(this.activeModuleIndex, true);
    }
  }

  getLatestPlayedVideo() {
    this.courseService.getLatestPlayedVideoOfCourse(this.purchasedCourseId).subscribe(
      (res: any) => {
        this.moduleId = res?.module?._id;
        this.getAllModules();
        this.getAllLessons(this.moduleId, false);
        this.onGetLesson(res?.lesson?._id);
      }
    )
  }

  isEmptyObject(obj) {
    return _.isEmpty(obj);
  }

  onClickFeedback() {
    this.isFeedback = true;
    this.isQuiz = false;
    this.isLesson = false;
  }

}
